import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import HandleRoute from './route/HandleRoute.js'
import GlobalSubscriptionNotification from './components/website/subscription/GlobalSubscriptionNotification';
// import './App.css';
// import logo from './images/logo.svg'

import './assets/css/all.min.css';
import './assets/bootstrap/css/bootstrap.min.css';
import './assets/css/owl.carousel.css';
import './assets/css/magnific-popup.css';
import './assets/css/animate.css';
import './assets/css/meanmenu.min.css';
import './assets/css/main.css';
import './assets/css/responsive.css'
import { useCart } from './context/CartContext';

function App() {

  const [role, setRole] = useState(null);

  useEffect(() => {
    // Fetch user role from API or use authentication state
    // For demonstration, setting role manually
    const userRole = ''; // or 'user'
    setRole(userRole);
  }, []);

  return (
    <Router>
      <div>
        <GlobalSubscriptionNotification />
        <HandleRoute />
      </div>
    </Router>
  );
}

export default App;